<template>
  <div class="read-only-module">
    <div class="header d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <i class="fas fa-info-circle mr-1"></i>
        <slot name="header"></slot>
      </div>
      <i class="fas fa-edit disabled-edit"></i>
    </div>
    <div class="body">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.header {
  background: var(--white);
  padding: 10px;
}
.body {
  padding: 10px;
}
.read-only-module {
  border: 1px solid var(--gray-border-color);
  background: #fff;
}
.disabled-edit {
  color: var(--secondary-color);
}
</style>
